import {
  COUNTRY_FETCH_REQUEST,
  COUNTRY_FETCH_REQUEST_SUCCESS,
  COUNTRY_FETCH_REQUEST_FAILURE,
  COUNTRY_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const countriesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case COUNTRY_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case COUNTRY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case COUNTRY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case COUNTRY_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        errors: {},
        loading: false,
      });

    default:
      return state;
  }
};

export default countriesReducer;
